export enum BusinessRoles {
  BusinessViewer = 'BusinessViewer',
  BusinessAdmin = 'BusinessAdmin',
  FinanceSiteAssigner = 'FinanceSiteAssigner',
}

export enum ExchangeRateRoles {
  ExchangeRateViewer = 'ExchangeRateViewer',
  ExchangeRateAdmin = 'ExchangeRateAdmin',
}

export enum CostingRoles {
  FinanceCostingAdmin = 'FinanceCostingAdmin',
  FinanceCostingStandardViewer = 'FinanceCostingStandardViewer',
  FinanceCalculatorAdmin = 'FinanceCalculatorAdmin',
}

export enum BankAccountRoles {
  BankAccountViewer = 'BankAccountViewer',
  BankAccountAdmin = 'BankAccountAdmin',
}

export enum BankTransactionRoles {
  BankTransactionViewer = 'BankTransactionViewer',
  BankTransactionAdmin = 'BankTransactionAdmin',
}

export enum MonthlyUploadsRoles {
  MonthlyUploadsViewer = 'MonthlyUploadsViewer',
  MonthlyUploadsAdmin = 'MonthlyUploadsAdmin',
}

export enum AccountsPayableRoles {
  AccountsPayableAdmin = 'AccountsPayableAdmin',
  AccountsPayableApprover = 'AccountsPayableApprover',
}

/** Read-only cost-center tree (#5841). */
export enum CostCenterRoles {
  CostCenterViewer = 'CostCenterViewer',
}

/** Expense concept catalogue (#5781). Viewer sees the list; Admin also creates and edits (checked by the API too). */
export enum ExpenseConceptRoles {
  ExpenseConceptViewer = 'ExpenseConceptViewer',
  ExpenseConceptAdmin = 'ExpenseConceptAdmin',
}

/** GL account rules screen (#5784). Viewer reads and previews; Admin also creates, edits and deactivates (checked by the API too). */
export enum GlAccountRuleRoles {
  GlAccountRuleViewer = 'GlAccountRuleViewer',
  GlAccountRuleAdmin = 'GlAccountRuleAdmin',
}

/**
 * Petty cash and trips (#5778). Approvers fill the default approval policies' slots; Treasurer and
 * ClaimAccountingReviewer gate actions; Viewer/Admin gate the pages (checked by the API too).
 */
export enum PettyCashRoles {
  TripApprover = 'TripApprover',
  AdvanceApprover = 'AdvanceApprover',
  FundMovementApprover = 'FundMovementApprover',
  ClaimApprover = 'ClaimApprover',
  PettyCashTreasurer = 'PettyCashTreasurer',
  ClaimAccountingReviewer = 'ClaimAccountingReviewer',
  PettyCashFundViewer = 'PettyCashFundViewer',
  PettyCashFundAdmin = 'PettyCashFundAdmin',
  TripViewer = 'TripViewer',
  TripAdmin = 'TripAdmin',
  ExpenseClaimViewer = 'ExpenseClaimViewer',
  ExpenseClaimAdmin = 'ExpenseClaimAdmin',
}

/** UserMaster approval policies (#5772): its policy list needs one of these, so pages only load it for them. */
export enum ApprovalPolicyRoles {
  ApprovalPolicyViewer = 'ApprovalPolicyViewer',
  ApprovalPolicyAdmin = 'ApprovalPolicyAdmin',
}

/** Sees Administrative (confidential) purchase orders and the AP documents that draw on them (#5942). */
export enum AdministrativePurchaseOrderRoles {
  AdministrativePurchaseOrderAdmin = 'AdministrativePurchaseOrderAdmin',
}

export enum SupportRoles {
  /** Reverses documents already posted in Finance (e.g. returning a posted AP payment to draft). */
  FinanceTransactionReversal = 'FinanceTransactionReversal',
}
